import React, {useState, useContext, useEffect } from 'react';
import { Card, Row, Col,  Modal , Form} from 'react-bootstrap';
import toast from 'react-hot-toast';
import { MDBInput } from 'mdb-react-ui-kit';
import API from '../../utils/api';
import $ from 'jquery';
import PsContext from '../../context';
import { PSListItem } from '../../comp';
import axios from 'axios';
import {integerIndMobile, lettersOnly} from '../../utils';
import {baseUrl, imageUrl} from '../../utils';
import ReactFileReader from 'react-file-reader';
import PLUSIMAGE from '../../assets/css/images/plus.png';
import {CKEditor} from 'ckeditor4-react';

const EditLedgerHead = (props) =>{

	const context = useContext(PsContext);
	const [submit, sethandleSubmit] = useState(false);
	const [validated, setValidated] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [btnLoading, setBtnLoading] = useState(false);
	const [edit, setEdit] = useState(false);
	const [imgData, setImgData] = useState(props.images);
	const [removeData, setRemoveData] = useState([]);
	const [feedback, setFeedback] = useState(props.edit.feedback);
	const [photos, setPhotos] = useState([]);
	const [data, changeData] = useState([]);
	const [stdata, stChangeData] = useState([]);
	const [staffData, setStaffData] = useState([]);
	
	useEffect(() => {
        setFeedback(props.edit.feedback);
        listGroupName(); 
		listLedgerHead();
    } , [] );
	

	const listLedgerHead = () => {
		try {
            setIsLoading(true);
			API.get('v1/user/list/ledgerthead').then(res => {
			if (res['data'].status == '1') {
                var d = res['data'].data;
				stChangeData(d);
                setIsLoading(false);
				}
			else {
				setIsLoading(false);
				}
			});
		}
		catch (error) {
            setIsLoading(false);
		}
	};
	
	const listGroupName = () => {
		try {
			setIsLoading(true);
			API.get('v1/user/list/ledgergroup').then(res => {
				if (res['data'].status == '1') {
					var d = res['data'].data;
					changeData(d);
					setIsLoading(false);
				}
				else {
					setIsLoading(false);
				}
			});
		}
		catch (error) {
			setIsLoading(false);
		}
	};
	
	const handleSubmit = (event) => {
		event.preventDefault();
		try{
			setBtnLoading(true);
			API.post('v1/user/editledgerhead',$("#meetform").serialize()).then(res=>{
				if (res['data'].status == '1') {
				  toast.success("LedgerHead Updated Successfully..!", "success");
				  document.getElementById("meetform").reset();
				  setBtnLoading(false);
				  props.afterFinish();
				  props.afterList();
				}	
				else {
				  toast.error("Something Went Wrong..!", "danger");
				  document.getElementById("editform").reset();
				}
				setIsLoading(false);
			});
		}
		catch(error){
			toast.error("Something Went Wrong..!", "danger");
		}
	};
	
	
	const handleDeleteClick = (id) =>  {
		try {
           var d = imgData.filter((item,i)=> item.id!=id);
			setImgData(d); 
			var r = [];
			r.push(id);
			const arr = [...removeData, ...r];
			setRemoveData(arr);
		}
		catch (error) {
            setIsLoading(false);
		}
	}
	
	const onFeedbackChange = (evt) => {
		setFeedback(evt.editor.getData());
	};

	return(
		<>
			<div className="container">
			<Form action="" method="post" id="meetform" validated={validated} onSubmit={handleSubmit} >
			<input type="hidden" name="group" value={props.edit.id} />
			<input type="hidden" name="id" value={props.edit.id} />
				<Row>
					<Col md={12}>
						<select className="form-control form-control-sm" name="ledger_group_id" required>
							<option value="">-Select Group Name-</option>
							{data.map((user, i) => {
							return <option value={user.id} selected={props.edit.ledger_group_id == user.id ? true : false}>{user.ledger_name}</option>
							})}
						</select> 
					</Col>
					{/*<Col md={12} className="mt-3">
						<select className="form-control form-control-sm" name="ledger_head_name" required>
							<option value="">-Select Ledger Head-</option>
							{stdata.map((user, i) => {
							return <option value={user.ledger_head_name} selected={props.edit.ledger_head_name == user.ledger_head_name ? true : false}>{user.ledger_head_name}</option>
							})}
						</select> 
					</Col> */}
					<Col md={12} className="mt-3">
						<MDBInput
							label="Ledger Head Name"
							type="text"
							name="ledger_head_name"
							size="sm"
							required
							onKeyPress={lettersOnly}
							defaultValue={props.edit.ledger_head_name}
						/>
					</Col>
				</Row>
				<Col className="mt-3">
					<button  className="btn btn-outline-black btn-block"  type="submit" disabled={btnLoading}>
							{btnLoading ? 'Please wait..' : 'Update'}</button>
				</Col>
			</Form>
			</div>
		</>
	);
};

export default EditLedgerHead;